var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1728_5490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5015 13.154L4.96304 10.8463H5.73227V9.30785H7.27073V10.8463H8.03996L6.5015 13.154ZM11.8861 1.61554V7.76939H1.11689V1.61554H11.8861ZM12.6553 0.846313H0.347656V8.53862H12.6553V0.846313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5021 2.38477C7.11414 2.38477 7.70111 2.6279 8.13389 3.06067C8.56667 3.49345 8.8098 4.08042 8.8098 4.69246C8.8098 5.3045 8.56667 5.89147 8.13389 6.32424C7.70111 6.75702 7.11414 7.00015 6.5021 7.00015H10.3483V6.23092H11.1175V3.154H10.3483V2.38477H6.5021ZM4.19441 4.69246C4.19441 4.08042 4.43754 3.49345 4.87032 3.06067C5.3031 2.6279 5.89007 2.38477 6.5021 2.38477H2.65595V3.154H1.88672V6.23092H2.65595V7.00015H6.5021C5.89007 7.00015 5.3031 6.75702 4.87032 6.32424C4.43754 5.89147 4.19441 5.3045 4.19441 4.69246Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1728_5490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3077,
    height: 12.3077,
    fill: "white",
    transform: "translate(0.347656 0.84613)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.0ded802684d7186b7518425637a7058e.svg";
export { ForwardRef as ReactComponent };